import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Icon } from "@animech/ui";
import { useEffect, useRef } from "react";
import * as Styled from "./component-select.style";
export var ComponentSelect = function (_a) {
    var labels = _a.labels, values = _a.values, images = _a.images, selectedValues = _a.selectedValues, onValueChange = _a.onValueChange, scrollIntoPosition = _a.scrollIntoPosition;
    var selectedItemRef = useRef(null);
    useEffect(function () {
        var _a;
        (_a = selectedItemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: "instant",
            block: scrollIntoPosition,
        });
    }, [scrollIntoPosition]);
    return (_jsx(Styled.ComponentSelectRoot, { onWheel: function (e) { return e.stopPropagation(); }, onMouseDown: function (e) { return e.stopPropagation(); }, children: values.map(function (value, i) {
            var image = images && images[i];
            var label = labels[i];
            var isSelected = selectedValues.includes(value);
            return (_jsxs(Styled.ComponentSelectItem, { ref: isSelected ? selectedItemRef : undefined, hasImage: Boolean(image), isSelected: isSelected, onClick: function () { return onValueChange(value); }, role: "button", tabIndex: 0, children: [image && (_jsx(Styled.Column, { children: _jsx("img", { src: image }) })), _jsx(Styled.Column, { children: _jsx("span", { children: label }) }), _jsx(Styled.Column, { children: isSelected && (_jsx(Icon, { scale: 1.25, name: "checkbox", color: "primary" })) })] }, value));
        }) }));
};
